<template>
  <h1 class="text-3xl mt-0 mb-4">
    <slot />
  </h1>
</template>
